import { AgentProvider } from "chat/context/AgentContext";
import { MyRuntimeProvider } from "chat/lib/remote-runtime-provider";
import { Thread } from "chat/components/thread";
import "chat.css";
import { ThreadList } from "@/components/thread-list";
import { useThreadList } from "@assistant-ui/react";
import { useAgentInfo } from "../../../../../layouts/agent/agent-info/_context/AgentInfoContext";

const ThreadListComponent = () => {
  const threadIds = useThreadList((s) => s.threads);
  if (threadIds?.length === 0) return;
  return (
    <div className="chat-sidebar flex flex-col rounded-xl">
      <ThreadList isLogsAgentPage={true} />
    </div>
  );
};

const Logs = () => {
  const { agentInfo } = useAgentInfo();
  return (
    <AgentProvider isLogsAgentPage={true}>
      <MyRuntimeProvider isLogsAgentPage={true}>
        <div className="chat-container relative flex h-[calc(100vh-350px)] flex-1 overflow-hidden">
          <ThreadListComponent />
          <div className="chat-main flex flex-1 flex-col">
            <Thread agentInfo={agentInfo} />
          </div>
        </div>
      </MyRuntimeProvider>
    </AgentProvider>
  );
};

export default Logs;
